
// Make Currency
function makeCurrency(amount, commas) {
	const symbol = document.body.getAttribute('data-currency-symbol');
	const trailingZeroes = document.body.getAttribute('data-currency-sample').includes('.00');
	if (trailingZeroes){
		if (typeof amount === 'string'){
			amount = parseInt(amount);
		}
		amount = amount.toFixed(2);
		if (commas === true){
			amount = amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		}
		let money = (symbol + amount);
		return money;
	} else {
		if (commas === true){
			amount = amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		}
		let money = symbol + amount;
		return money;
	}
}
